import React, { useMemo } from 'react';
import {
  FormCardDefaultHeader,
  FormCardBody,
  FormCard,
} from '@bingads-webui-fluent-component/form-cards';
import { mergeClasses, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { useStyles, getSkeletonStyles } from './style';
import { IContentPanel } from './type';

const SegmentSkeleton = ({ lineCount }: { lineCount: number }) => {
  const classes = getSkeletonStyles();

  return (
    <Skeleton className={classes.row}>
      {Array(lineCount).fill('').map(() => <SkeletonItem size={20} />)}
    </Skeleton>
  );
};

export const ContentPanel = React.memo(({
  title,
  bodyContent,
  isLoading,
  lineCount = 3,
  error,
  headerProps = {},
  helpTopic = '',
  helpLabel = '',
}: IContentPanel) => {
  const classes = useStyles();

  const renderHelpBubble = useMemo(() => (
    <>
      {helpTopic && <HelpButton topic={helpTopic} aria-label={helpLabel} />}
    </>
  ), [helpLabel, helpTopic]);

  return (
    <FormCard error={error} className={mergeClasses('brandkit-content-panel', classes.contentPanel)}>
      <FormCardDefaultHeader titleAs="h2" title={title} contentAfter={renderHelpBubble} {...headerProps} />
      <FormCardBody>
        {isLoading ?
          <SegmentSkeleton lineCount={lineCount} /> :
          <>
            {bodyContent}
          </>
        }
      </FormCardBody>
    </FormCard>
  );
});
